import { createAction } from '@reduxjs/toolkit';

import {
  GET_MODEL_BY_ID,
  GET_MODELS_BY_SEARCH_MODEL_QUERY,
} from './actionTypes';

export const getModelsBySearchModelQuery = createAction<{
  maxResult?: number;
  sellerId?: string;
  searchTerms: string;
}>(GET_MODELS_BY_SEARCH_MODEL_QUERY.BASE);

export const getModelById = createAction(GET_MODEL_BY_ID.BASE);
